export default {
  namespaced: true,

  state: () => ({
    articleCategories: {
      data: [],
      links: {},
      meta: {},
    },
    articleCategoryAll: [],
    articleCategory: {},
    isLoading: false,
  }),

  getters: {},

  mutations: {
    SET_ARTICLE_CATEGORIES_LIST(state, payload) {
      state.articleCategories = payload
    },
    SET_ARTICLE_CATEGORIES(state, payload) {
      state.articleCategory = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getCategoriesArticle({ commit }, { page = null, keyword = '', limit = 20 } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/article-categories?filter[keyword]=${keyword}`

        const response = await this._vm.$http.get(url,
          {
            params: {
              page,
              limit,
            },
          })

        commit('SET_ARTICLE_CATEGORIES_LIST', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async deleteCategoriesArticle({ commit, dispatch }, { articleCategoryId }) {
      try {
        const url = `/v1/admin/article-categories/${articleCategoryId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getCategoriesArticle')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Kategori Artikel!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Kategori Artikel!',
        }, { root: true })

        return error
      }
    },
    async createCategoriesArticle({ commit }, data) {
      try {
        const url = '/v1/admin/article-categories'
        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Kategori Artikel!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Kategori Artikel!',
        }, { root: true })

        return error
      }
    },
    async getCategoryArticle({ commit }, { id }) {
      try {
        const url = `/v1/admin/article-categories/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_ARTICLE_CATEGORIES', response.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async updateCategoryArticle({ commit }, { articleCategoryId, data }) {
      try {
        const url = `/v1/admin/article-categories/${articleCategoryId}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Kategori Artikel!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Kategori Artikel!',
        }, { root: true })

        return error
      }
    },
  },
}
